import { BreakPoints } from './../../types/theme';

export const breakpoints: BreakPoints = {
	xs: 'screen and (max-width: 442px)',
	sm: 'screen and (max-width: 640px)',
	md: 'screen and (max-width: 768px)',
	lg: 'screen and (max-width: 1024px)',
	xl: 'screen and (max-width: 1280px)',
};
